var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderMaintenance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 500 500",
    height: 950,
    width: 1024,
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_262"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.22,494.75c0,0 5.58,173.04 150.05,288.39c144.47,115.35 344.63,123.61 506.7,134.56c162.05,10.97 286.52,-80.77 305.29,-219.44c18.75,-138.69 -105.08,-179.39 -172.27,-337.25c-67.19,-157.87 -61.21,-209.75 -203.35,-306.85c-142.16,-97.08 -364.54,-37.47 -481.14,128.86c-116.6,166.34 -105.28,311.73 -105.28,311.73z",
    fill: "#55AE7B",
    id: "svg_2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.22,494.75c0,0 5.58,173.04 150.05,288.39c144.47,115.35 344.63,123.61 506.7,134.56c162.05,10.97 286.52,-80.77 305.29,-219.44c18.75,-138.69 -105.08,-179.39 -172.27,-337.25c-67.19,-157.87 -61.21,-209.75 -203.35,-306.85c-142.16,-97.08 -364.54,-37.47 -481.14,128.86c-116.6,166.34 -105.28,311.73 -105.28,311.73z",
    fill: "#FFFFFF",
    id: "svg_3",
    opacity: 0.7
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Clouds"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m968.11,177.59c1.43,-8.02 3.47,-27.96 -8.66,-37.72c-15.39,-12.42 -26.31,9.91 -39.72,-7.45c-13.41,-17.39 -17.36,-55.12 -57.1,-54.62c-39.72,0.48 -42.68,22.84 -42.68,30.29s-11.93,12.9 -14.4,12.9c-2.48,0 -16.4,-6.44 -21.36,7.96c-4.97,14.4 -1.58,22.73 -9.49,23.03c-7.87,0.29 -17.67,-10.46 -28.42,-5.08c-10.75,5.36 -10.75,16.79 -15.21,20.77c-4.46,3.96 -11.91,-2.99 -21.85,0.99c-6.02,2.4 -7.82,6.26 -8.33,8.92l267.22,0l0,0.01z",
    fill: "#FFFFFF",
    id: "svg_5",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m191.57,160.97c1.01,-5.63 2.44,-19.61 -6.07,-26.46c-10.79,-8.7 -18.46,6.97 -27.85,-5.21c-9.41,-12.2 -12.2,-38.66 -40.05,-38.31c-27.87,0.35 -29.96,16.02 -29.96,21.23c0,5.23 -8.35,9.06 -10.09,9.06c-1.76,0 -11.49,-4.53 -14.99,5.58c-3.47,10.09 -1.12,15.93 -6.66,16.13c-5.52,0.22 -12.4,-7.32 -19.93,-3.56c-7.52,3.78 -7.52,11.8 -10.66,14.57c-3.14,2.79 -8.35,-2.09 -15.32,0.7c-4.22,1.69 -5.49,4.4 -5.85,6.26l187.41,0l0.02,0.01z",
    fill: "#FFFFFF",
    id: "svg_6",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m734.45,444.5c1.01,-5.63 2.44,-19.61 -6.07,-26.46c-10.79,-8.7 -18.46,6.97 -27.87,-5.21c-9.39,-12.2 -12.18,-38.66 -40.02,-38.31c-27.87,0.35 -29.96,16.02 -29.96,21.23c0,5.23 -8.35,9.06 -10.11,9.06c-1.74,0 -11.47,-4.53 -14.97,5.58c-3.47,10.09 -1.12,15.93 -6.66,16.13c-5.52,0.22 -12.4,-7.32 -19.93,-3.56c-7.54,3.78 -7.54,11.8 -10.66,14.57c-3.14,2.79 -8.35,-2.09 -15.32,0.7c-4.22,1.69 -5.49,4.4 -5.85,6.26l187.41,0l0.01,0.01z",
    fill: "#FFFFFF",
    id: "svg_7",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m868.11,96.27c0.44,-2.55 1.1,-8.86 -2.75,-11.96c-4.86,-3.91 -8.33,3.14 -12.57,-2.35c-4.24,-5.49 -5.52,-17.45 -18.09,-17.3c-12.57,0.15 -13.52,7.23 -13.52,9.6c0,2.35 -3.78,4.09 -4.55,4.09c-0.79,0 -5.19,-2.04 -6.77,2.51c-1.56,4.55 -0.51,7.19 -3.01,7.3c-2.48,0.09 -5.58,-3.32 -8.99,-1.6c-3.41,1.69 -3.41,5.32 -4.81,6.57c-1.43,1.25 -3.78,-0.95 -6.92,0.31c-1.91,0.77 -2.48,2 -2.64,2.84l84.62,0l0,-0.01z",
    fill: "#FFFFFF",
    id: "svg_8",
    stroke: "#263238",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Graphics"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_9",
    stroke: "#263238",
    strokeMiterlimit: 10,
    x1: 239.16,
    x2: 239.16,
    y1: 449.4,
    y2: 439.38
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_10",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 811.73,
    cy: 195.02,
    fill: "none",
    id: "svg_11",
    r: 8.4,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 337.75,
    fill: "none",
    id: "svg_12",
    r: 8.4,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 706.78,
    cy: 772.23,
    fill: "none",
    id: "svg_13",
    r: 8.4,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.7,
    cy: 702.95,
    fill: "none",
    id: "svg_14",
    r: 8.4,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_15"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_16",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 659.02,
    x2: 641.2,
    y1: 341.42,
    y2: 359.25
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_17",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 659.02,
    x2: 641.2,
    y1: 359.25,
    y2: 341.42
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_18"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_19",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 595.02,
    x2: 612.85,
    y1: 853.57,
    y2: 871.38
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_20",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 612.85,
    x2: 595.02,
    y1: 853.57,
    y2: 871.38
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_21"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_22",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 34.62,
    x2: 52.43,
    y1: 452.68,
    y2: 470.48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_23",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 52.43,
    x2: 34.62,
    y1: 452.68,
    y2: 470.48
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_24"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_25",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 691.57,
    x2: 709.4,
    y1: 37.08,
    y2: 54.9
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_26",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 709.4,
    x2: 691.57,
    y1: 37.08,
    y2: 54.9
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 822.72,
    cy: 718.12,
    fill: "none",
    id: "svg_27",
    r: 8.4,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 930.84,
    cy: 469.07,
    fill: "none",
    id: "svg_28",
    r: 8.4,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_29"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_30",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 702.56,
    x2: 720.39,
    y1: 560.18,
    y2: 578
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_31",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 720.39,
    x2: 702.56,
    y1: 560.18,
    y2: 578
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_32"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_33",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 895.45,
    x2: 913.25,
    y1: 418.3,
    y2: 436.11
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_34",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 913.25,
    x2: 895.45,
    y1: 418.3,
    y2: 436.11
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_35"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_36",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 259.2,
    x2: 277.01,
    y1: 51.78,
    y2: 69.59
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_37",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 277.01,
    x2: 259.2,
    y1: 51.78,
    y2: 69.59
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Device"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_39"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#55AE7B",
    height: 821.77,
    id: "svg_40",
    opacity: 0.5,
    width: 443.6,
    x: 134.91,
    y: 86.62
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    id: "svg_41",
    opacity: 0.3,
    points: "443.6253490447998,86.61408996582031 134.91557121276855,625.1754150390625 134.91557121276855,817.8605346679688 554.0740489959717,86.61408996582031 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    id: "svg_42",
    opacity: 0.3,
    points: "578.5102672576904,423.1998291015625 571.1758556365967,417.90289306640625 304.3491039276123,889.2547607421875 311.62415885925293,908.3851318359375 578.5102672576904,908.3851318359375 "
  }), /*#__PURE__*/React.createElement("path", {
    d: "m591.81,248.3c3.03,0 5.49,-2.46 5.49,-5.47l0,-54.79c0,-3.03 -2.46,-5.49 -5.49,-5.49c-0.35,0 -0.68,0.04 -1.01,0.11l0,-102.49c0,-19.52 -15.82,-35.34 -35.34,-35.34l-389.36,0c-19.52,0 -35.32,15.82 -35.32,35.34l0,827.05c0,19.52 15.82,35.34 35.32,35.34l389.36,0c19.52,0 35.34,-15.82 35.34,-35.34l0,-503.14c0.33,0.07 0.66,0.09 1.01,0.09c3.03,0 5.49,-2.44 5.49,-5.47l0,-54.79c0,-3.03 -2.46,-5.47 -5.49,-5.47c-0.35,0 -0.68,0.04 -1.01,0.09l0,-12.37c0.33,0.07 0.66,0.11 1.01,0.11c3.03,0 5.49,-2.46 5.49,-5.47l0,-54.82c0,-3.01 -2.46,-5.47 -5.49,-5.47c-0.35,0 -0.68,0.04 -1.01,0.11l0,-12.4c0.33,0.07 0.68,0.11 1.01,0.11l0,-0.03zm-21.47,640.95l-419.09,0l0,-783.46l419.09,0l0,783.46z",
    fill: "#263238",
    id: "svg_43"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Gears"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m426.77,664.12l0,-24.29l-25.3,-2.88c-0.75,-4.95 -1.96,-9.74 -3.54,-14.37l21.08,-15.43l-12.31,-21.01l-23.41,9.98c-3.12,-3.85 -6.57,-7.43 -10.31,-10.7l10.44,-23.76l-21.34,-12.13l-15.19,20.15c-4.62,-1.78 -9.41,-3.21 -14.37,-4.2l-3.01,-25.67l-24.62,0l-2.92,24.92c-5.01,0.75 -9.89,1.93 -14.57,3.47l-15.65,-20.77l-21.34,12.13l10.13,23.08c-3.91,3.08 -7.54,6.48 -10.86,10.18l-24.09,-10.29l-12.33,21.01l20.46,14.97c-1.8,4.57 -3.25,9.3 -4.24,14.18l-26.07,2.97l0,24.29l25.3,2.88c0.75,4.95 1.96,9.74 3.52,14.37l-21.06,15.41l12.31,21.03l23.39,-9.98c3.14,3.85 6.59,7.43 10.33,10.68l-10.44,23.78l21.34,12.13l15.19,-20.18c4.62,1.78 9.41,3.21 14.37,4.2l3.01,25.69l24.62,0l2.92,-24.95c5.01,-0.73 9.89,-1.91 14.57,-3.47l15.65,20.79l21.34,-12.15l-10.13,-23.06c3.89,-3.08 7.54,-6.48 10.84,-10.18l24.11,10.29l12.31,-21.03l-20.44,-14.97c1.8,-4.55 3.25,-9.28 4.24,-14.18l26.07,-2.95l0,0.02zm-111.68,43.52c-32.35,0 -58.57,-25.85 -58.57,-57.76c0,-31.89 26.22,-57.74 58.57,-57.74c32.35,0 58.57,25.85 58.57,57.74c0,31.91 -26.22,57.76 -58.57,57.76z",
    fill: "none",
    id: "svg_45",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m535.83,542.81l0,-15.69l-16.33,-1.85c-0.51,-3.21 -1.27,-6.31 -2.29,-9.3l13.63,-9.96l-7.96,-13.6l-15.12,6.46c-2.02,-2.48 -4.26,-4.79 -6.68,-6.92l6.75,-15.34l-13.78,-7.85l-9.82,13.03c-2.97,-1.16 -6.07,-2.07 -9.28,-2.73l-1.96,-16.59l-15.91,0l-1.89,16.11c-3.23,0.48 -6.37,1.25 -9.41,2.24l-10.11,-13.41l-13.8,7.85l6.55,14.9c-2.53,1.98 -4.86,4.18 -7.01,6.57l-15.58,-6.66l-7.96,13.6l13.23,9.67c-1.16,2.95 -2.11,6 -2.75,9.17l-16.86,1.91l0,15.69l16.35,1.85c0.48,3.21 1.27,6.31 2.29,9.3l-13.63,9.96l7.96,13.6l15.12,-6.46c2.02,2.48 4.24,4.81 6.66,6.92l-6.73,15.34l13.78,7.85l9.8,-13.03c2.99,1.16 6.09,2.07 9.3,2.73l1.96,16.59l15.91,0l1.89,-16.11c3.23,-0.48 6.37,-1.25 9.41,-2.26l10.11,13.43l13.78,-7.85l-6.53,-14.9c2.51,-1.98 4.86,-4.2 7.01,-6.57l15.56,6.66l7.96,-13.6l-13.21,-9.67c1.16,-2.95 2.09,-6 2.75,-9.17l16.84,-1.91zm-72.16,28.13c-20.9,0 -37.87,-16.7 -37.87,-37.32c0,-20.62 16.97,-37.32 37.87,-37.32s37.85,16.7 37.85,37.32c0,20.62 -16.95,37.32 -37.85,37.32z",
    fill: "none",
    id: "svg_46",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_47"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m788.39,319.49l5.76,-15.98l-13.3,-7.25l-10.33,13.5c-2.99,-0.7 -6.02,-1.03 -9.06,-0.97l-7.23,-15.36l-14.53,4.26l2.24,16.84c-2.57,1.6 -4.95,3.52 -7.08,5.74l-16,-5.76l-7.23,13.3l13.47,10.33c-0.68,2.99 -1.01,6.02 -0.97,9.06l-15.36,7.23l4.29,14.51l16.81,-2.22c1.6,2.55 3.52,4.92 5.74,7.08l-5.74,15.98l13.28,7.25l10.33,-13.5c3.01,0.7 6.04,1.03 9.06,0.99l7.23,15.36l14.53,-4.29l-2.24,-16.81c2.57,-1.6 4.95,-3.52 7.1,-5.74l15.98,5.74l7.25,-13.28l-13.5,-10.33c0.7,-3.01 1.03,-6.04 0.97,-9.06l15.36,-7.23l-4.26,-14.53l-16.84,2.24c-0.4,-0.64 -0.81,-1.25 -1.23,-1.87m-48.86,37.72c-6.44,-7.32 -7.98,-18.18 -3.03,-27.25c6.33,-11.6 20.86,-15.87 32.46,-9.56c11.6,6.33 15.87,20.86 9.56,32.46c-5.71,10.48 -18.11,14.99 -28.99,11.12",
    fill: "none",
    id: "svg_48",
    opacity: 0.3,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m736.65,280.67l8.9,4.84l6.9,-9.01c2.02,0.46 4.04,0.68 6.07,0.64l4.86,10.29l9.71,-2.86l-1.49,-11.28c1.71,-1.05 3.3,-2.35 4.73,-3.82l10.7,3.85l4.86,-8.9l-9.03,-6.9c0.46,-2 0.68,-4.04 0.66,-6.07l10.26,-4.84l-2.86,-9.71l-11.25,1.49c-1.08,-1.71 -2.35,-3.3 -3.85,-4.75l3.85,-10.7l-8.88,-4.84l-6.92,9.01c-2,-0.46 -4.02,-0.68 -6.04,-0.64l-4.86,-10.29l-9.71,2.86l1.49,11.28c-1.71,1.05 -3.3,2.35 -4.73,3.82l-10.7,-3.85l-4.84,8.9l9.01,6.9c-0.46,2 -0.68,4.04 -0.66,6.07l-10.26,4.84l2.86,9.71l11.25,-1.49c1.08,1.71 2.35,3.3 3.85,4.75l-3.87,10.7l-0.01,0zm26.18,-13.56c-3.98,1.21 -8.4,0.9 -12.33,-1.25c-7.76,-4.24 -10.62,-13.96 -6.4,-21.72c4.24,-7.78 13.96,-10.64 21.74,-6.4c7.76,4.22 10.62,13.96 6.37,21.72c-0.44,0.86 -0.97,1.63 -1.56,2.35",
    fill: "none",
    id: "svg_49",
    opacity: 0.3,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_51"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m184.17,44.84l0,744.23c0,8.29 10.84,11.39 15.23,4.37l0,0c0.81,-1.32 1.25,-2.81 1.25,-4.37l0,-744.23",
    fill: "none",
    id: "svg_52",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m243.2,260.25c0,0 0.33,1.69 1.67,3.36c1.36,1.69 3.71,0.68 3.71,2.7s-3.36,4.7 -3.36,4.7s-1.01,10.77 -3.03,14.13c-2.02,3.36 -12.11,0.35 -12.11,0.35l-2.7,8.4l-29.28,-2.35l1.69,-11.1l-3.03,-16.84c0,0 1.34,-6.73 6.73,-9.08c5.38,-2.35 26.92,-0.68 30.97,0c4.02,0.66 8.75,5.71 8.75,5.71l-0.01,0.02z",
    fill: "#FFFFFF",
    id: "svg_54",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196.76,263.62c0,0 1.34,13.47 3.01,16.84s7.41,4.7 15.82,3.36c8.42,-1.34 12.11,-4.04 13.12,-7.41c1.01,-3.36 3.03,-9.43 4.37,-9.76c1.36,-0.33 1.69,-0.33 2.37,1.69s-1.69,4.02 0.66,2.02c2.35,-2.02 3.03,-10.77 3.03,-10.77s-20.53,2.68 -29.28,2.68c-8.75,0 -12.79,-0.68 -12.79,-0.68l-0.33,2.02l0.02,0.01z",
    fill: "#263238",
    id: "svg_55",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195.4,263.29c0,0 -0.66,15.14 8.09,20.53c8.75,5.38 19.52,-0.33 23.56,-4.04c4.02,-3.69 6.04,-15.14 6.04,-15.14l-4.02,0.35c0,0 1.34,8.4 -8.77,11.43c-10.09,3.03 -13.12,2.35 -16.15,0c-3.01,-2.35 -7.38,-12.79 -7.38,-12.79l-1.36,-0.33l-0.01,-0.01z",
    fill: "#FFFFFF",
    id: "svg_56",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195.75,248.47c0,0 0.33,11.45 -0.68,13.14c-1.01,1.67 -1.01,1.67 -1.01,1.67s5.71,6.07 25.58,4.73c19.85,-1.36 32.64,-10.77 32.64,-10.77l-6.4,-6.07c0,0 0.35,-12.79 -8.75,-20.2c-9.08,-7.41 -30.29,-2.68 -35.67,4.04c-5.38,6.73 -6.07,11.1 -5.71,13.45l0,0.01z",
    fill: "#FFFFFF",
    id: "svg_57",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m165.11,373l-0.66,13.45l65.63,1.36l-1.36,-12.79c0,0 -5.38,-2.7 -21.87,-5.06c-16.48,-2.35 -32.99,-0.68 -35.67,-0.68c-2.7,0 -5.71,0.68 -5.71,0.68l-0.35,3.03l-0.01,0.01z",
    fill: "#55AE7B",
    id: "svg_58",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    id: "svg_59",
    points: "339.48026847839355,234.9237060546875 329.4205150604248,234.9237060546875 328.4622325897217,234.9237060546875 318.4002513885498,234.9237060546875 326.62919425964355,240.41183471679688 326.62919425964355,276.44635009765625 330.91068840026855,276.44635009765625 330.91068840026855,240.473388671875 331.25135612487793,240.41183471679688 ",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 3.6,
    id: "svg_60",
    stroke: "#263238",
    strokeMiterlimit: 10,
    width: 64.68,
    x: 296.13,
    y: 232.54
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m172.1,296.17c0,0 -8.92,4.7 -8.92,12.68c0,7.98 -16.92,36.64 -16.92,52.13c0,15.5 9.87,13.14 16.44,9.85c6.57,-3.27 13.14,-8.92 13.14,-8.92l3.76,-61.98c0.02,0 -0.92,-4.22 -7.49,-3.76l-0.01,0z",
    fill: "#FFFFFF",
    id: "svg_62",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m172.1,296.17c0,0 -8.92,4.7 -8.92,12.68c0,3.38 -3.06,10.51 -6.57,18.77l20.53,13.08l2.46,-40.77c0.02,0 -0.92,-4.22 -7.49,-3.76l-0.01,0z",
    fill: "#FFFFFF",
    id: "svg_63",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m230.74,295.6c0,0 -1.69,-3.69 -5.38,-5.38c-3.69,-1.69 -20.2,-4.7 -25.91,-4.7s-9.08,5.38 -9.08,5.38l40.38,4.7l-0.01,0z",
    fill: "#FFFFFF",
    id: "svg_65",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m194.06,289.88c0,0 -9.76,1.67 -19.19,5.03c-9.41,3.38 -9.08,13.14 -9.41,21.89c-0.35,8.75 -1.01,42.4 -1.34,47.1c-0.35,4.73 -0.35,8.42 0.99,9.1c1.36,0.66 23.91,-2.35 37.36,-0.68c13.45,1.69 22.88,5.74 26.24,3.71c3.36,-2.02 4.04,-7.08 4.04,-10.77c0,-3.71 14.13,-32.66 14.13,-32.66s51.83,9.76 52.84,9.43c1.01,-0.33 29.63,-53.17 29.63,-53.17s7.38,-5.06 8.4,-6.75c1.01,-1.67 -0.33,-10.77 -0.33,-11.76s0.33,-4.37 0.33,-6.75c0,-2.35 -4.02,-4.37 -4.7,-3.36c-0.68,1.01 -2.02,2.02 -2.02,2.02l-3.36,4.73c0,0 -0.68,-5.74 -1.69,-7.08c-1.01,-1.34 -5.03,0 -3.36,2.7c1.69,2.68 1.01,4.37 0,6.37c-1.01,2.02 -2.02,5.06 -2.02,9.78c0,4.7 -1.67,11.1 -1.67,11.1s-24.9,22.2 -27.61,24.9c-2.68,2.68 -3.69,4.04 -3.69,4.04s-24.9,-13.8 -30.97,-16.51c-6.07,-2.68 -25.91,-6.73 -25.91,-6.73s-25.23,-5.71 -36.68,-5.71l-0.01,0.03z",
    fill: "#FFFFFF",
    id: "svg_66",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.65,302.32c-6.04,-2.68 -25.91,-6.73 -25.91,-6.73s-25.23,-5.71 -36.68,-5.71c0,0 -9.76,1.67 -19.19,5.03c-9.41,3.36 -9.08,13.14 -9.41,21.89c-0.35,8.75 -1.01,42.4 -1.34,47.1c-0.35,4.73 -0.35,8.42 0.99,9.1c1.36,0.66 23.91,-2.35 37.36,-0.68c13.47,1.69 22.88,5.74 26.24,3.71c3.36,-2.02 4.04,-7.08 4.04,-10.77c0,-3.71 14.13,-32.66 14.13,-32.66s7.67,1.45 17.19,3.21l9.01,-24.95c-6.62,-3.58 -13.6,-7.28 -16.44,-8.55l0.01,0.01z",
    fill: "#FFFFFF",
    id: "svg_67",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m218.7,375.42c-3.23,-5.91 -9.58,-18.26 -16.55,-36.42c-8.2,-21.3 -12.18,-41.25 -13.39,-48.05c-2.15,0.48 -4.77,1.14 -7.58,1.96l0.44,0.33c0,0 0.11,0.44 0.33,1.25c2.31,8.57 16,58.82 25.83,78.64c4.18,0.73 7.82,1.58 10.92,2.29z",
    fill: "#55AE7B",
    id: "svg_69",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m169.57,372.94c2.44,-0.15 5.69,-0.4 9.32,-0.64l54.68,-76.11c-1.74,-0.37 -2.84,-0.59 -2.84,-0.59l-6.07,-0.68l-55.1,78.03l0.01,-0.01z",
    fill: "#55AE7B",
    id: "svg_70",
    stroke: "#263238",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svg_71"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m265.75,431.56c0,0 -104.33,1.69 -107.04,0c-2.68,-1.69 -8.07,-6.73 -5.38,-19.85c2.7,-13.14 11.12,-25.25 11.12,-25.25l65.61,1.36l4.4,11.43c0,0 28.26,5.71 38.35,13.12s-3.36,20.2 -3.36,20.2",
    fill: "#263238",
    id: "svg_72",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m234.46,399.25c0,0 2.02,8.75 2.68,11.78",
    fill: "#FFFFFF",
    id: "svg_73",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "m159.07,435.25l8.42,81.78l19.85,1.34c0,0 2.35,-63.61 2.35,-64.95s2.02,-17.82 2.02,-17.82l-32.64,-0.35z",
    fill: "#263238",
    id: "svg_74",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_75"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m167.49,517.03c0,0 -2.02,16.51 -0.35,18.18s16.48,2.02 18.51,0c2.02,-2.02 1.36,-18.18 1.36,-18.18l-19.52,0z",
    fill: "#FFFFFF",
    id: "svg_76",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.91,529.43l-20.42,-0.24c-0.09,2.95 0.04,5.43 0.64,6.02c1.69,1.69 16.48,2.02 18.51,0c0.7,-0.68 1.08,-3.01 1.27,-5.78z",
    fill: "#FFFFFF",
    id: "svg_77",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "m237.47,435.93l-9.41,82.79l18.84,0c0,0 3.03,-8.09 3.03,-9.76c0,-1.69 -1.69,-6.73 -1.69,-6.73l18.18,-64.97l-28.95,-1.34l0,0.01z",
    fill: "#263238",
    id: "svg_78",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_79"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m246.9,518.73c0,0 6.4,6.04 10.44,7.41c4.02,1.34 9.41,3.69 9.41,5.71c0,2.02 -10.09,3.03 -17.5,3.03c-7.41,0 -22.88,-3.03 -22.88,-3.03l1.69,-13.12l18.84,0z",
    fill: "#FFFFFF",
    id: "svg_80",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m266.74,531.85c0,-0.42 -0.24,-0.88 -0.66,-1.32c-3.12,0.51 -7.49,0.99 -12.79,0.99c-8.79,0 -21.83,-3.14 -26.33,-4.31l-0.59,4.64c0,0 15.47,3.03 22.88,3.03c7.41,0 17.5,-1.01 17.5,-3.03l-0.01,0z",
    fill: "#FFFFFF",
    id: "svg_81",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_82"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m270.79,485.08c0,0 9.1,-22.9 12.79,-35.34c3.71,-12.46 6.4,-7.08 6.4,-2.35c0,4.7 -14.81,38.02 -15.47,40.73c-0.68,2.68 -6.07,2.35 -3.71,-3.03l-0.01,-0.01z",
    fill: "#FFFFFF",
    id: "svg_83",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    id: "svg_84",
    points: "279.80082511901855,527.47021484375 243.28500175476074,527.47021484375 235.46049308776855,475.98004150390625 287.6253185272217,475.98004150390625 ",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238.48,475.65c0,0 2.9,-26.59 23.56,-26.24c20.86,0.33 22.55,26.24 22.55,26.24",
    fill: "none",
    id: "svg_85",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_86"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 7.74,
    id: "svg_87",
    stroke: "#263238",
    strokeMiterlimit: 10,
    width: 142.36,
    x: 134.5,
    y: 430.88
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    height: 7.74,
    id: "svg_88",
    stroke: "#263238",
    strokeMiterlimit: 10,
    width: 31.63,
    x: 245.23,
    y: 430.88
  })))), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_89",
    stroke: "#263238",
    strokeMiterlimit: 10,
    x1: 294.77,
    x2: 294.77,
    y1: 174.1,
    y2: 164.47
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_90",
    stroke: "#263238",
    strokeMiterlimit: 10,
    x1: 294.77,
    x2: 294.77,
    y1: 227.81,
    y2: 180.86
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_91",
    stroke: "#263238",
    strokeMiterlimit: 10,
    x1: 361.52,
    x2: 361.52,
    y1: 228.38,
    y2: 195.02
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Security_Barrier"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_92"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_93"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_94"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#263238",
    id: "svg_95",
    points: "429.96986198425293,942.5382690429688 412.9185619354248,942.5382690429688 435.65357780456543,784.0458984375 452.70487785339355,784.0458984375 ",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    id: "svg_96",
    points: "464.0723705291748,942.5382690429688 481.1236400604248,942.5382690429688 458.3886241912842,784.0458984375 441.3373546600342,784.0458984375 ",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("polygon", {
    fill: "#263238",
    id: "svg_97",
    points: "671.9339122772217,942.5382690429688 654.8849010467529,942.5382690429688 677.6199474334717,784.0458984375 694.6712169647217,784.0458984375 ",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    id: "svg_98",
    points: "706.0387096405029,942.5382690429688 723.0899791717529,942.5382690429688 700.3527355194092,784.0458984375 683.3036632537842,784.0458984375 ",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_99"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#55AE7B",
    height: 31.54,
    id: "svg_100",
    stroke: "#263238",
    strokeMiterlimit: 10,
    width: 325.22,
    x: 392.73,
    y: 759.2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#55AE7B",
    height: 31.54,
    id: "svg_101",
    stroke: "#263238",
    strokeMiterlimit: 10,
    width: 325.22,
    x: 400.66,
    y: 759.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_102"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#263238",
    id: "svg_103",
    points: "405.9798107147217,790.7274169921875 433.5875988006592,790.7274169921875 447.8518810272217,759.1964111328125 420.24415397644043,759.1964111328125 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#263238",
    id: "svg_104",
    points: "515.2437877655029,759.1964111328125 487.63822746276855,759.1964111328125 473.3738536834717,790.7274169921875 500.9794445037842,790.7274169921875 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#263238",
    id: "svg_105",
    points: "717.4216442108154,759.1964111328125 689.8161144256592,759.1964111328125 675.5517101287842,790.7274169921875 703.1572399139404,790.7274169921875 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#263238",
    id: "svg_106",
    points: "650.0297374725342,759.1964111328125 622.4242076873779,759.1964111328125 608.1598644256592,790.7274169921875 635.7653942108154,790.7274169921875 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#263238",
    id: "svg_107",
    points: "582.6378917694092,759.1964111328125 555.0301036834717,759.1964111328125 540.7658214569092,790.7274169921875 568.3735485076904,790.7274169921875 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_108"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_109",
    stroke: "#263238",
    strokeMiterlimit: 10,
    x1: 724.1,
    x2: 670.28,
    y1: 773.18,
    y2: 773.18
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_110",
    stroke: "#263238",
    strokeMiterlimit: 10,
    x1: 723.16,
    x2: 714.65,
    y1: 778.45,
    y2: 778.45
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_111",
    stroke: "#263238",
    strokeMiterlimit: 10,
    x1: 399.28,
    x2: 453.1,
    y1: 777.13,
    y2: 777.13
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_112",
    stroke: "#263238",
    strokeMiterlimit: 10,
    x1: 400.22,
    x2: 468.2,
    y1: 771.2,
    y2: 771.2
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Cone"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_113"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_114"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#263238",
    height: 6.22,
    id: "svg_115",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 82.93,
    x: 722.74,
    y: 936.33
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_116"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#55AE7B",
    id: "svg_117",
    points: "791.6797008514404,936.1445922851562 736.7411022186279,936.1445922851562 758.2760753631592,819.010009765625 770.1447277069092,819.010009765625 ",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    id: "svg_118",
    points: "750.2713146209717,862.5458984375 778.1472301483154,862.5458984375 775.4789562225342,848.035400390625 752.9395885467529,848.035400390625 ",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("line", {
    fill: "#55AE7B",
    id: "svg_119",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 783.42,
    x2: 784.79,
    y1: 916.61,
    y2: 924.61
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#55AE7B",
    id: "svg_120",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 767.73,
    x2: 781.69,
    y1: 825.49,
    y2: 906.52
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_122"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_123",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 922.37,
    x2: 947.54,
    y1: 623.26,
    y2: 864.56
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_124"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_125"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_126",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 943.5,
    x2: 932.07,
    y1: 818.39,
    y2: 806.32
  }), /*#__PURE__*/React.createElement("path", {
    d: "m935.54,809.95c0,0 0.33,-5.34 -4.55,-9.69c-2.92,-2.62 -18.35,-9.1 -19.8,-3.67c-1.6,5.91 14.2,17.52 24.35,13.36z",
    fill: "#55AE7B",
    id: "svg_127",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_128",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    x1: 935.54,
    x2: 920.86,
    y1: 809.95,
    y2: 800.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_129"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_130",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 946.35,
    x2: 934.95,
    y1: 845.84,
    y2: 833.77
  }), /*#__PURE__*/React.createElement("path", {
    d: "m938.4,837.38c0,0 0.33,-5.32 -4.53,-9.67c-2.95,-2.62 -18.35,-9.1 -19.83,-3.67c-1.58,5.91 14.2,17.5 24.35,13.34l0.01,0z",
    fill: "#55AE7B",
    id: "svg_131",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_132",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    x1: 938.4,
    x2: 923.72,
    y1: 837.38,
    y2: 828.23
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_133"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_134",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 936.51,
    x2: 925.08,
    y1: 751.42,
    y2: 739.37
  }), /*#__PURE__*/React.createElement("path", {
    d: "m928.55,742.98c0,0 0.33,-5.34 -4.55,-9.69c-2.92,-2.62 -18.35,-9.1 -19.8,-3.67c-1.6,5.91 14.2,17.52 24.35,13.36z",
    fill: "#55AE7B",
    id: "svg_135",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_136",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    x1: 928.55,
    x2: 913.87,
    y1: 742.98,
    y2: 733.83
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_137"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_138",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 939.36,
    x2: 927.96,
    y1: 778.87,
    y2: 766.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m931.41,770.43c0,0 0.33,-5.34 -4.53,-9.69c-2.95,-2.62 -18.35,-9.1 -19.83,-3.67c-1.58,5.91 14.2,17.52 24.35,13.36l0.01,0z",
    fill: "#55AE7B",
    id: "svg_139",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_140",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    x1: 931.41,
    x2: 916.73,
    y1: 770.43,
    y2: 761.26
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_141"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_142",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 931.85,
    x2: 920.44,
    y1: 706.84,
    y2: 694.78
  }), /*#__PURE__*/React.createElement("path", {
    d: "m923.89,698.4c0,0 0.33,-5.34 -4.53,-9.69c-2.95,-2.62 -18.35,-9.1 -19.83,-3.67c-1.58,5.91 14.2,17.52 24.35,13.36l0.01,0z",
    fill: "#55AE7B",
    id: "svg_143",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_144",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    x1: 923.89,
    x2: 909.21,
    y1: 698.4,
    y2: 689.26
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_145"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_146",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 927.17,
    x2: 915.76,
    y1: 662.07,
    y2: 650.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "m919.23,653.63c0,0 0.33,-5.34 -4.55,-9.69c-2.92,-2.62 -18.35,-9.1 -19.83,-3.67c-1.58,5.91 14.2,17.52 24.37,13.36l0.01,0z",
    fill: "#55AE7B",
    id: "svg_147",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_148",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    x1: 919.23,
    x2: 904.55,
    y1: 653.63,
    y2: 644.47
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_149"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_150",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 941.56,
    x2: 950.24,
    y1: 802.14,
    y2: 787.99
  }), /*#__PURE__*/React.createElement("path", {
    d: "m947.61,792.25c0,0 -1.43,-5.17 2.44,-10.42c2.33,-3.16 16.09,-12.7 18.64,-7.69c2.77,5.45 -10.26,20.07 -21.08,18.11z",
    fill: "#55AE7B",
    id: "svg_151",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_152",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    x1: 947.61,
    x2: 960.82,
    y1: 792.25,
    y2: 779.62
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_153"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_154",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 934.02,
    x2: 942.71,
    y1: 729.94,
    y2: 715.79
  }), /*#__PURE__*/React.createElement("path", {
    d: "m940.07,720.03c0,0 -1.43,-5.14 2.44,-10.42c2.33,-3.16 16.09,-12.68 18.64,-7.69c2.77,5.47 -10.26,20.07 -21.08,18.11z",
    fill: "#55AE7B",
    id: "svg_155",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_156",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    x1: 940.07,
    x2: 953.28,
    y1: 720.03,
    y2: 707.39
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_157"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_158",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 930.73,
    x2: 939.41,
    y1: 698.21,
    y2: 684.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "m936.75,688.29c0,0 -1.41,-5.14 2.46,-10.42c2.33,-3.16 16.07,-12.68 18.62,-7.69c2.79,5.47 -10.26,20.07 -21.08,18.11z",
    fill: "#55AE7B",
    id: "svg_159",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_160",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    x1: 936.75,
    x2: 949.98,
    y1: 688.29,
    y2: 675.66
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_161"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_162",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 925.87,
    x2: 934.55,
    y1: 651.68,
    y2: 637.52
  }), /*#__PURE__*/React.createElement("path", {
    d: "m931.89,641.76c0,0 -1.41,-5.14 2.46,-10.42c2.33,-3.16 16.07,-12.68 18.62,-7.67c2.79,5.45 -10.26,20.04 -21.08,18.09z",
    fill: "#55AE7B",
    id: "svg_163",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_164",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    x1: 931.89,
    x2: 945.12,
    y1: 641.76,
    y2: 629.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "m922.15,621.92c0,0 -1.43,-5.14 2.44,-10.4c2.33,-3.16 16.09,-12.7 18.64,-7.69c2.77,5.45 -10.29,20.07 -21.08,18.09z",
    fill: "#55AE7B",
    id: "svg_165",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_166",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    x1: 922.15,
    x2: 935.36,
    y1: 621.92,
    y2: 609.28
  }), /*#__PURE__*/React.createElement("path", {
    d: "m922.92,622.47c0,0 -5.27,0.88 -10.11,-3.52c-2.9,-2.66 -10.95,-17.32 -5.69,-19.34c5.71,-2.2 18.88,12.33 15.8,22.86z",
    fill: "#55AE7B",
    id: "svg_167",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_168",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    x1: 922.92,
    x2: 911.74,
    y1: 622.47,
    y2: 608
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svg_169"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_170",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 988.8,
    x2: 963.74,
    y1: 656.49,
    y2: 897.82
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_171"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_172"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_173",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 969.28,
    x2: 960.6,
    y1: 851.79,
    y2: 837.64
  }), /*#__PURE__*/React.createElement("path", {
    d: "m963.23,841.88c0,0 1.43,-5.14 -2.44,-10.42c-2.33,-3.16 -16.09,-12.68 -18.64,-7.67c-2.77,5.47 10.29,20.07 21.08,18.09z",
    fill: "#55AE7B",
    id: "svg_174",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_175",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    x1: 963.23,
    x2: 950.75,
    y1: 841.88,
    y2: 829.9
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_176"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_177",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 976.22,
    x2: 967.54,
    y1: 784.82,
    y2: 770.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "m970.2,774.91c0,0 1.41,-5.14 -2.46,-10.42c-2.33,-3.16 -16.09,-12.68 -18.64,-7.67c-2.77,5.45 10.29,20.07 21.1,18.09z",
    fill: "#55AE7B",
    id: "svg_178",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_179",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    x1: 970.2,
    x2: 957.72,
    y1: 774.91,
    y2: 762.93
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_180"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_181",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 973.39,
    x2: 964.68,
    y1: 812.25,
    y2: 798.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "m967.34,802.36c0,0 1.41,-5.14 -2.46,-10.42c-2.33,-3.16 -16.07,-12.68 -18.62,-7.67c-2.79,5.45 10.26,20.07 21.08,18.09z",
    fill: "#55AE7B",
    id: "svg_182",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_183",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    x1: 967.34,
    x2: 954.86,
    y1: 802.36,
    y2: 790.39
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_184"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_185",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 980.86,
    x2: 972.18,
    y1: 740.23,
    y2: 726.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m974.82,730.34c0,0 1.43,-5.17 -2.44,-10.42c-2.33,-3.16 -16.09,-12.68 -18.64,-7.67c-2.79,5.45 10.29,20.04 21.08,18.09z",
    fill: "#55AE7B",
    id: "svg_186",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_187",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    x1: 974.82,
    x2: 962.33,
    y1: 730.34,
    y2: 718.36
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_188"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_189",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 985.5,
    x2: 976.82,
    y1: 695.46,
    y2: 681.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m979.48,685.57c0,0 1.41,-5.17 -2.46,-10.42c-2.33,-3.16 -16.09,-12.68 -18.64,-7.67c-2.77,5.45 10.29,20.04 21.1,18.09z",
    fill: "#55AE7B",
    id: "svg_190",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_191",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    x1: 979.48,
    x2: 966.97,
    y1: 685.57,
    y2: 673.59
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_192"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_193",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 970.75,
    x2: 982.16,
    y1: 835.51,
    y2: 823.44
  }), /*#__PURE__*/React.createElement("path", {
    d: "m978.68,827.05c0,0 -0.33,-5.32 4.55,-9.67c2.92,-2.62 18.33,-9.12 19.8,-3.69c1.6,5.91 -14.18,17.52 -24.35,13.36z",
    fill: "#55AE7B",
    id: "svg_194",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_195",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    x1: 978.68,
    x2: 994.22,
    y1: 827.05,
    y2: 817.42
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_196"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_197",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 978.25,
    x2: 989.65,
    y1: 763.29,
    y2: 751.22
  }), /*#__PURE__*/React.createElement("path", {
    d: "m986.18,754.82c0,0 -0.33,-5.32 4.55,-9.67c2.92,-2.62 18.35,-9.12 19.8,-3.69c1.6,5.91 -14.18,17.52 -24.35,13.36z",
    fill: "#55AE7B",
    id: "svg_198",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_199",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    x1: 986.18,
    x2: 1001.72,
    y1: 754.82,
    y2: 745.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_200"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_201",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 981.54,
    x2: 992.95,
    y1: 731.55,
    y2: 719.48
  }), /*#__PURE__*/React.createElement("path", {
    d: "m989.48,723.09c0,0 -0.33,-5.32 4.55,-9.67c2.92,-2.62 18.33,-9.12 19.8,-3.69c1.6,5.91 -14.18,17.52 -24.35,13.36z",
    fill: "#55AE7B",
    id: "svg_202",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_203",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    x1: 989.48,
    x2: 1005.02,
    y1: 723.09,
    y2: 713.46
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_204"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_205",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 986.36,
    x2: 997.76,
    y1: 685.02,
    y2: 672.95
  }), /*#__PURE__*/React.createElement("path", {
    d: "m994.31,676.56c0,0 -0.33,-5.32 4.53,-9.67c2.95,-2.62 18.35,-9.12 19.83,-3.69c1.58,5.91 -14.2,17.52 -24.35,13.36l-0.01,0z",
    fill: "#55AE7B",
    id: "svg_206",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_207",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    x1: 994.31,
    x2: 1009.85,
    y1: 676.56,
    y2: 666.93
  }), /*#__PURE__*/React.createElement("path", {
    d: "m988.86,655.15c0,0 -0.33,-5.34 4.53,-9.69c2.92,-2.62 18.35,-9.12 19.83,-3.69c1.58,5.91 -14.2,17.52 -24.35,13.39l-0.01,-0.01z",
    fill: "#55AE7B",
    id: "svg_208",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_209",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    x1: 988.86,
    x2: 1004.4,
    y1: 655.15,
    y2: 645.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m989.5,655.83c0,0 -5.34,-0.22 -9.17,-5.54c-2.29,-3.19 -7.14,-19.19 -1.58,-20.09c6.04,-0.97 15.93,15.96 10.75,25.63z",
    fill: "#55AE7B",
    id: "svg_210",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_211",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    x1: 989.5,
    x2: 981.52,
    y1: 655.83,
    y2: 639.37
  })))), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_212",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 960.09,
    x2: 960.09,
    y1: 558.22,
    y2: 863.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_213"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_214"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_215",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 960.33,
    x2: 950.22,
    y1: 817.51,
    y2: 804.34
  }), /*#__PURE__*/React.createElement("path", {
    d: "m953.3,808.28c0,0 0.88,-5.25 -3.52,-10.09c-2.64,-2.92 -17.3,-10.97 -19.32,-5.71c-2.2,5.71 12.31,18.88 22.84,15.8z",
    fill: "#55AE7B",
    id: "svg_216",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_217",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    x1: 953.3,
    x2: 939.65,
    y1: 808.28,
    y2: 797.66
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_218"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_219",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 960.33,
    x2: 950.22,
    y1: 760.16,
    y2: 746.98
  }), /*#__PURE__*/React.createElement("path", {
    d: "m953.3,750.93c0,0 0.88,-5.27 -3.52,-10.11c-2.64,-2.9 -17.3,-10.95 -19.32,-5.69c-2.2,5.69 12.31,18.88 22.84,15.8z",
    fill: "#55AE7B",
    id: "svg_220",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_221",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    x1: 953.3,
    x2: 939.65,
    y1: 750.93,
    y2: 740.32
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_222"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_223",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 960.33,
    x2: 950.22,
    y1: 692.84,
    y2: 679.66
  }), /*#__PURE__*/React.createElement("path", {
    d: "m953.3,683.61c0,0 0.88,-5.27 -3.52,-10.11c-2.64,-2.9 -17.3,-10.97 -19.32,-5.71c-2.2,5.71 12.31,18.9 22.84,15.82z",
    fill: "#55AE7B",
    id: "svg_224",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_225",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    x1: 953.3,
    x2: 939.65,
    y1: 683.61,
    y2: 672.97
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_226"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_227",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 960.33,
    x2: 950.22,
    y1: 648.01,
    y2: 634.84
  }), /*#__PURE__*/React.createElement("path", {
    d: "m953.3,638.77c0,0 0.88,-5.25 -3.52,-10.09c-2.64,-2.9 -17.3,-10.97 -19.32,-5.71c-2.2,5.71 12.31,18.88 22.84,15.8z",
    fill: "#55AE7B",
    id: "svg_228",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_229",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    x1: 953.3,
    x2: 939.65,
    y1: 638.77,
    y2: 628.16
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_230"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_231",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 960.33,
    x2: 950.22,
    y1: 602.99,
    y2: 589.81
  }), /*#__PURE__*/React.createElement("path", {
    d: "m953.3,593.76c0,0 0.88,-5.27 -3.52,-10.09c-2.64,-2.92 -17.3,-10.97 -19.32,-5.71c-2.2,5.71 12.31,18.88 22.84,15.8z",
    fill: "#55AE7B",
    id: "svg_232",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_233",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    x1: 953.3,
    x2: 939.65,
    y1: 593.76,
    y2: 583.15
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_234"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_235",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 960.11,
    x2: 970.22,
    y1: 835.02,
    y2: 821.84
  }), /*#__PURE__*/React.createElement("path", {
    d: "m967.15,825.79c0,0 -0.88,-5.27 3.52,-10.11c2.64,-2.9 17.3,-10.95 19.32,-5.69c2.2,5.69 -12.31,18.88 -22.84,15.8z",
    fill: "#55AE7B",
    id: "svg_236",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_237",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    x1: 967.15,
    x2: 981.61,
    y1: 825.79,
    y2: 814.61
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_238"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_239",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 960.11,
    x2: 970.22,
    y1: 743.81,
    y2: 730.62
  }), /*#__PURE__*/React.createElement("path", {
    d: "m967.15,734.58c0,0 -0.88,-5.27 3.52,-10.09c2.64,-2.92 17.3,-10.97 19.32,-5.71c2.2,5.71 -12.31,18.88 -22.84,15.8z",
    fill: "#55AE7B",
    id: "svg_240",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_241",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    x1: 967.15,
    x2: 981.61,
    y1: 734.58,
    y2: 723.39
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_242"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_243",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 960.11,
    x2: 970.22,
    y1: 698.8,
    y2: 685.61
  }), /*#__PURE__*/React.createElement("path", {
    d: "m967.15,689.57c0,0 -0.88,-5.27 3.52,-10.11c2.64,-2.9 17.3,-10.95 19.32,-5.69c2.2,5.69 -12.31,18.88 -22.84,15.8z",
    fill: "#55AE7B",
    id: "svg_244",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_245",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    x1: 967.15,
    x2: 981.61,
    y1: 689.57,
    y2: 678.38
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_246"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_247",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 960.11,
    x2: 970.22,
    y1: 639.3,
    y2: 626.11
  }), /*#__PURE__*/React.createElement("path", {
    d: "m967.15,630.07c0,0 -0.88,-5.27 3.52,-10.11c2.64,-2.9 17.3,-10.95 19.32,-5.71c2.2,5.71 -12.31,18.9 -22.84,15.82z",
    fill: "#55AE7B",
    id: "svg_248",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_249",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    x1: 967.15,
    x2: 981.61,
    y1: 630.07,
    y2: 618.86
  })), /*#__PURE__*/React.createElement("g", {
    id: "svg_250"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_251",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    x1: 960.11,
    x2: 970.22,
    y1: 592.51,
    y2: 579.34
  }), /*#__PURE__*/React.createElement("path", {
    d: "m967.15,583.3c0,0 -0.88,-5.27 3.52,-10.11c2.64,-2.9 17.3,-10.97 19.32,-5.71c2.2,5.71 -12.31,18.9 -22.84,15.82z",
    fill: "#55AE7B",
    id: "svg_252",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_253",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    x1: 967.15,
    x2: 981.61,
    y1: 583.3,
    y2: 572.09
  }), /*#__PURE__*/React.createElement("path", {
    d: "m959.5,562.55c0,0 -0.88,-5.27 3.52,-10.11c2.64,-2.9 17.32,-10.97 19.34,-5.71c2.2,5.71 -12.31,18.9 -22.86,15.82z",
    fill: "#55AE7B",
    id: "svg_254",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_255",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    x1: 959.5,
    x2: 973.96,
    y1: 562.55,
    y2: 551.34
  }), /*#__PURE__*/React.createElement("path", {
    d: "m960.22,563.17c0,0 -5.34,0.33 -9.69,-4.55c-2.62,-2.95 -9.08,-18.37 -3.65,-19.83c5.91,-1.58 17.5,14.22 13.34,24.37l0,0.01z",
    fill: "#55AE7B",
    id: "svg_256",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_257",
    stroke: "#263238",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    x1: 960.22,
    x2: 950.6,
    y1: 563.17,
    y2: 547.61
  }))), /*#__PURE__*/React.createElement("polygon", {
    fill: "#263238",
    id: "svg_258",
    points: "972.6500377655029,942.5382690429688 940.3321056365967,942.5382690429688 936.2924327850342,860.9172973632812 976.6897106170654,860.9172973632812 ",
    stroke: "#263238",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_259"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_260",
    stroke: "#263238",
    strokeMiterlimit: 10,
    x1: 895.67,
    x2: 1019.85,
    y1: 942.55,
    y2: 942.55
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    id: "svg_261",
    stroke: "#263238",
    strokeMiterlimit: 10,
    x1: 35.19,
    x2: 884.68,
    y1: 942.55,
    y2: 942.55
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderMaintenance);
export default __webpack_public_path__ + "static/media/under_maintenance.c2abcac10fc205aedca95c8c775de307.svg";
export { ForwardRef as ReactComponent };